// @ts-nocheck

import { MPFamilyIds } from '../types/families';

export const MPColors = {
  [MPFamilyIds.BROWN]: '#905539',
  [MPFamilyIds.PURPLE]: '#CB4193',
  [MPFamilyIds.ORANGE]: '#EB902A',
  [MPFamilyIds.DARK_BLUE]: '#0072B7',
  [MPFamilyIds.LIGHT_BLUE]: '#AFDDF5',
  [MPFamilyIds.RED]: '#E1242E',
  [MPFamilyIds.GREEN]: '#3AAD59',
  [MPFamilyIds.YELLOW]: '#FFED00',
};
